export default __webpack_public_path__ + "assets/apple-touch-icon.e5a9dc9a1bef5136a9f18da8e5aa38bc.png";